import ConfirmOrder from './ConfirmOrder'

export default ConfirmOrder
